import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { CalendarService } from '../../../services/calendar.service';
import { MonthlyTagData } from '../../../interfaces/appointment.interface';

@Component({
  selector: 'app-reusable-calendar',
  templateUrl: './reusable-calendar.component.html',
  styleUrls: ['./reusable-calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReusableCalendarComponent implements OnChanges {
  @Input() selectedDate: Date | null = null;
  @Input() monthlyTags: MonthlyTagData[] = [];
  @Input() daysOfMonth: number[] = [];
  @Input() title: string = 'Calendário';
  @Input() showNavigation: boolean = true;
  @Input() disabled: boolean = false;
  @Input() minDate: Date | null = null;
  @Input() maxDate: Date | null = null;

  @Output() dateSelected = new EventEmitter<Date>();
  @Output() monthChanged = new EventEmitter<Date>();

  dateClassFunction: MatCalendarCellClassFunction<Date> = () => '';

  constructor(private calendarService: CalendarService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['monthlyTags'] || changes['daysOfMonth']) {
      this.updateDateClassFunction();
    }
  }

  private updateDateClassFunction(): void {
    if (this.monthlyTags.length > 0 && this.daysOfMonth.length > 0) {
      this.dateClassFunction = this.calendarService.createDateClassFunction(
        this.monthlyTags.map(tag => ({ tag: tag.tag, date: new Date().toISOString() })),
        this.daysOfMonth
      );
    }
  }

  onDateSelected(date: Date | null): void {
    if (date && !this.disabled) {
      this.dateSelected.emit(date);
    }
  }

  onMonthChanged(date: Date): void {
    this.monthChanged.emit(date);
  }

  getCalendarTitle(): string {
    return this.title;
  }
}
